"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextButtonIcon = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ButtonIconMixin = require("../../mixins/components/ButtonIconMixin");
/**
 * @since 8.12.0
 */
var TextButtonIcon = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "TextButtonIcon",
  componentId: "c11n-8-107-0__sc-1penltx-0"
})(["", ""], _ButtonIconMixin.ButtonIconMixin);
exports.TextButtonIcon = TextButtonIcon;
TextButtonIcon.displayName = 'TextButtonIcon';

/** @component */